import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://multi-counter.bancheng.tech/api';

/**
 * Get all companies
 */
export const getAllCompanies = async () => {
  try {
    const response = await axios.get(`${API_URL}/companies`);
    return response.data;
  } catch (error) {
    console.error('Error getting all companies:', error);
    throw error;
  }
};

/**
 * Get company by ID
 */
export const getCompany = async (companyId) => {
  try {
    const response = await axios.get(`${API_URL}/companies/${companyId}`);
    return response.data;
  } catch (error) {
    console.error('Error getting company:', error);
    throw error;
  }
};

/**
 * Create or update company (upsert)
 */
export const upsertCompany = async (companyData) => {
  try {
    const payload = {
      '名稱': companyData.companyName || companyData.名稱,
      '廣告': companyData.allowGlobalAds !== undefined ? companyData.allowGlobalAds : companyData.廣告,
      '🔒 Row ID': companyData.id || companyData['🔒 Row ID'],
      'soundSettings': companyData.soundSettings
    };

    const response = await axios.post(`${API_URL}/companies/upsert`, payload);
    return response.data.company;
  } catch (error) {
    console.error('Error upserting company:', error);
    throw error;
  }
};

/**
 * Create company (wrapper for upsert without ID)
 */
export const createCompany = async (companyData) => {
  return upsertCompany({
    名稱: companyData.companyName,
    廣告: companyData.allowGlobalAds !== undefined ? companyData.allowGlobalAds : true,
    soundSettings: companyData.soundSettings
  });
};

/**
 * Update company (wrapper for upsert with ID)
 */
export const updateCompany = async (companyId, updates) => {
  return upsertCompany({
    '🔒 Row ID': companyId,
    名稱: updates.companyName,
    廣告: updates.allowGlobalAds,
    soundSettings: updates.soundSettings
  });
};

/**
 * Delete company
 */
export const deleteCompany = async (companyId) => {
  try {
    await axios.delete(`${API_URL}/companies/${companyId}`);
    return { success: true, companyId };
  } catch (error) {
    console.error('Error deleting company:', error);
    throw error;
  }
};

/**
 * Subscribe to all companies (polling implementation)
 */
export const subscribeToAllCompanies = (callback) => {
  const fetchData = async () => {
    try {
      const companies = await getAllCompanies();
      callback(companies);
    } catch (error) {
      console.error('Error fetching companies:', error);
    }
  };

  // Initial fetch
  fetchData();

  // Poll every 5 seconds
  const intervalId = setInterval(fetchData, 5000);

  // Return cleanup function
  return () => clearInterval(intervalId);
};
